import { Table } from 'react-dsgov';
import { BrButton, BrLoading } from '@govbr-ds/react-components';
import styles from './ncmTable.module.scss';

import { useEffect } from 'react';
import { ICodigoNcm } from '../../../../interfaces/IBaseDeCalculo';
import { formatCurrency } from '../../../../utils/formatCurrency';

interface IHeader {
  field: string;
  label: string;
}

interface IProps {
  isLoading: boolean;
  listaCodigosNCM: ICodigoNcm[];
  setListaCodigosNCM: React.Dispatch<React.SetStateAction<ICodigoNcm[]>>;
  headers: IHeader[];
}

export const NcmTable = ({ isLoading, listaCodigosNCM, setListaCodigosNCM, headers }: IProps) => {
  useEffect(() => {}, [listaCodigosNCM]);
  const hasDeducoesColumn = headers.some((header) => header.label === 'Deduções');

  const getTotalDeducoes = (ncm: ICodigoNcm) => {
    const deducoes = ((ncm as any).deducoes ?? (ncm as any).tributosValores) as any;

    if (Array.isArray(deducoes)) {
      return deducoes.reduce((acc: number, item: any) => acc + (Number(item?.valor) || 0), 0);
    }

    return Number(deducoes) || 0;
  };

  const excluirNcm = (ncm: ICodigoNcm) => {
    //TODO - colocar modal perguntando se quer excluir mesmo
    const novaListaCodigosNCM = listaCodigosNCM.filter(
      (obj) => !(obj.codigoNCM === ncm.codigoNCM && obj.quantidade === ncm.quantidade && obj.valor === ncm.valor)
    );
    setListaCodigosNCM(novaListaCodigosNCM);
  };

  return (
    <div className={styles.container}>
      <div className={styles.componentesTitle}>Códigos NCM Adicionados ao Componente de Base de Cálculo</div>
      <div className={styles.customTable}>
        {listaCodigosNCM.length === 0 && !isLoading ? (
          <Table
            showTopBar={false}
            headers={headers}
            showPagination={false}
            showDensityButtons={false}
            showSearch={false}
            density='medium'
          >
            <tbody className={styles.noRecords}>
              <tr>
                <div>
                  Não há itens para serem exibidos.
                  <br /> Por favor adicione um código NCM.
                  <br /> <br />
                </div>
              </tr>
            </tbody>
          </Table>
        ) : (
          <Table
            showTopBar={false}
            headers={headers}
            showPagination={false}
            showDensityButtons={false}
            showSearch={false}
            density='medium'
            className={styles.aquisicaoTable}
          >
            <tbody>
              {listaCodigosNCM.map((row, index) => (
                <tr key={index}>
                  {headers.map((header) => {
                    if (header?.label === 'Excluir')
                      return (
                        <>
                          <td align='center' key={header.field}>
                            <div className={styles.statusColumn}>
                              <BrButton secondary circle onClick={() => excluirNcm(row)} title='Excluir'>
                                <i className={`fas fa-trash-alt fa-md  ${styles.columnIcon}`} />
                              </BrButton>
                            </div>
                          </td>
                          :
                        </>
                      );
                    if (header?.label === 'Valor de Aquisição' || header?.label === 'Valor de Arrematação')
                      return (
                        <td align='center' key={header.field}>
                          {formatCurrency(row[header.field as keyof ICodigoNcm] as string)}
                        </td>
                      );
                    if (header?.label === 'Deduções')
                      return (
                        <td align='center' key={header.field}>
                          {formatCurrency(getTotalDeducoes(row).toFixed(2))}
                        </td>
                      );
                    if (header?.label === 'Quantidade')
                      return (
                        <td align='center' key={header.field}>
                          {row[header.field].toString().replace('.', ',')}
                        </td>
                      );
                    if (header?.label === 'Preço Unitário')
                      return (
                        <td align='center' key={header.field}>
                          {row['quantidade'] === '' || row['valor'] === ''
                            ? 'x'
                            : formatCurrency((parseFloat(row.valor) / parseFloat(row.quantidade)).toFixed(2))}
                        </td>
                      );
                    return (
                      <td align='center' key={header.field}>
                        {row[header.field as keyof ICodigoNcm] as string}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className={styles.tableFooter}>
                <th align='center'>Total</th>
                <th align='center'>
                  {listaCodigosNCM
                    .reduce((acc, item) => acc + parseFloat(item.quantidade), 0)
                    .toString()
                    .replace('.', ',')}
                </th>
                <th align='center'>-</th>
                <th align='center'>
                  {formatCurrency(listaCodigosNCM.reduce((acc, item) => acc + parseFloat(item.valor), 0).toFixed(2))}
                </th>
                {hasDeducoesColumn && (
                  <th align='center'>
                    {formatCurrency(listaCodigosNCM.reduce((acc, item) => acc + getTotalDeducoes(item), 0).toFixed(2))}
                  </th>
                )}
                <th align='center'></th>
              </tr>
            </tfoot>
          </Table>
        )}
        {isLoading && (
          <div className={styles.tableLoading}>
            <BrLoading large label='Carregando...' />
          </div>
        )}
      </div>
    </div>
  );
};
